// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-hn-module--logo--2G5cq"};